import { optionsToString, stringToOption } from "@app/utils/CommonUtils";
import { CddMeCheckStatusOptions, ProcessPriorityOptions } from "@pages/dvtjcuv/common/Constant";

export const findOneOptionByValue = (options, strStatus) => {
    if (!strStatus || !options) {
        return '';
    }

    return options.find(option => option.value.toString() === strStatus.toString());

}

export const getProcessPriorityOption = (processPriority) => {
    if (processPriority) {
        return ProcessPriorityOptions.find(option => option.value.toString() === processPriority.toString())
    }
    return { label: "", value: "" }
}

export const pipelineStringToOptions = (inputPipeline) => {
    const pipeline = { ...inputPipeline }
    pipeline.cdd_me_check_status = findOneOptionByValue(CddMeCheckStatusOptions, pipeline.cdd_me_check_status)
    pipeline.gp_cdd_process = stringToOption(pipeline.gp_cdd_process, true)
    pipeline.us_qualify_cdd = stringToOption(pipeline.us_qualify_cdd, true)
    pipeline.to_do_w_cdd = stringToOption(pipeline.to_do_w_cdd, true)
    pipeline.gp_emp_process = stringToOption(pipeline.gp_emp_process, false)
    pipeline.invite_send_job_todo_w_rec = stringToOption(pipeline.invite_send_job_todo_w_rec, false)
    pipeline.invite_send_job_gp_emp_process = stringToOption(pipeline.invite_send_job_gp_emp_process, false)
    pipeline.matching_potential = stringToOption(pipeline.matching_potential, false)
    pipeline.cdd_emp_process = stringToOption(pipeline.cdd_emp_process, false)
    pipeline.cdd_emp_fu_needed = stringToOption(pipeline.cdd_emp_fu_needed, true)
    pipeline.payment_and_warranty = stringToOption(pipeline.payment_and_warranty, false)
    pipeline.gd_tt_bh_fu_needed = stringToOption(pipeline.gd_tt_bh_fu_needed, true)
    pipeline.cdd_receiver_me_check_status = findOneOptionByValue(CddMeCheckStatusOptions, pipeline.cdd_receiver_me_check_status, false)
    pipeline.interactive_channel = stringToOption(pipeline.interactive_channel, false)
    pipeline.process_priority = getProcessPriorityOption(pipeline.process_priority)
    return pipeline
}

export const pipelineOptionsToString = (jobPipeline) => {
    const body = { ...jobPipeline }
    body.cdd_me_check_status = optionsToString(jobPipeline.cdd_me_check_status, false)
    body.gp_cdd_process = optionsToString(jobPipeline.gp_cdd_process, true)
    body.us_qualify_cdd = optionsToString(jobPipeline.us_qualify_cdd, true)
    body.to_do_w_cdd = optionsToString(jobPipeline.to_do_w_cdd, true)
    body.receiver_comment_cdd = optionsToString(jobPipeline.receiver_comment_cdd, true)
    body.gp_emp_process = optionsToString(jobPipeline.gp_emp_process, false)
    body.invite_send_job_todo_w_rec = optionsToString(jobPipeline.invite_send_job_todo_w_rec, false)
    body.invite_send_job_gp_emp_process = optionsToString(jobPipeline.invite_send_job_gp_emp_process, false)
    body.matching_potential = optionsToString(jobPipeline.matching_potential, false)
    body.cdd_emp_process = optionsToString(jobPipeline.cdd_emp_process, false)
    body.cdd_emp_fu_needed = optionsToString(jobPipeline.cdd_emp_fu_needed, true)
    body.payment_and_warranty = optionsToString(jobPipeline.payment_and_warranty, false)
    body.gd_tt_bh_fu_needed = optionsToString(jobPipeline.gd_tt_bh_fu_needed, true)
    body.cdd_receiver_me_check_status = optionsToString(jobPipeline.cdd_receiver_me_check_status, false)
    body.interactive_channel = optionsToString(jobPipeline.interactive_channel, false)
    return body
}
